import apiClient from '../api/apiClient';
import {ResponseDto} from "./ResponseDto";
import {MemberWithdrawalTypes} from "../types/member/member.withdrawal.types";
import {MemberSettingTypes} from "../types/member/member.setting.types";

// 회원 정보 조회
export const getMemberInfo = () =>
    apiClient.get('/api/front/member/info');

export const getMemberSetting = () =>
    apiClient.get<ResponseDto<MemberSettingTypes>>("/api/front/member/setting");

// 마케팅 수신동의 변경
export const updateMarketingConsent = (marketingConsent: boolean) =>
    apiClient.post<ResponseDto<any>>("/api/front/member/marketing-consent",
        {marketingConsent: marketingConsent}
    );


// 비밀번호 변경
export const changePassword = (currentPassword: string, newPassword: string) =>
    apiClient.put('/api/front/member/changePassword', {
        currentPassword,
        newPassword
    });

// 회원 계좌 삭제
export const deleteMemberAccountNo = () => apiClient.patch<ResponseDto<any>>('/api/front/member/deleteMemberAccountNo', {});



export const withdrawalMember = (data: MemberWithdrawalTypes) =>
    apiClient.post<ResponseDto<any>>('/api/front/member/withdrawalMember', data);

// 휴대폰번호 변경 (PASS 본인인증 후)
export const changePhone = (verifiedName: string, newPhone: string) =>
    apiClient.put<ResponseDto<any>>('/api/front/member/changePhone', {
        verifiedName,
        newPhone
    });